import React, { useEffect, useRef } from "react";
import { Container, Typography } from "@mui/material";
import "./Carousel2.css";

// Import service images 37-46
import krinvyservice37 from "../assets/images/Krinvy_aftereffects.png";
import krinvyservice38 from "../assets/images/Krinvy_blender.png";
import krinvyservice39 from "../assets/images/Krinvy_canva.png";
import krinvyservice40 from "../assets/images/Krinvy_capcut.png";
import krinvyservice41 from "../assets/images/Krinvy_figma.png";
import krinvyservice42 from "../assets/images/Krinvy_finalcut.png";
import krinvyservice43 from "../assets/images/Krinvy_illustrator.png";
import krinvyservice44 from "../assets/images/Krinvy_lightroom.png";
import krinvyservice45 from "../assets/images/Krinvy_photoshop.png";
import krinvyservice46 from "../assets/images/Krinvy_premier.png";

const images = [
    krinvyservice37,
    krinvyservice38,
    krinvyservice39,
    krinvyservice40,
    krinvyservice41,
    krinvyservice42,
    krinvyservice43,
    krinvyservice44,
    krinvyservice45,
    krinvyservice46
];

const Carousel2 = () => {
    const trackRef = useRef(null);
    
    useEffect(() => {
        const track = trackRef.current;
        let animationFrameId;
        
        const animate = () => {
            if (track) {
                const currentTransform = window.getComputedStyle(track).getPropertyValue('transform');
                const matrix = new DOMMatrix(currentTransform);
                const currentX = matrix.m41;
                
                if (currentX <= -track.scrollWidth / 2) {
                    track.style.transform = 'translateX(0)';
                } else {
                    track.style.transform = `translateX(${currentX - 1}px)`;
                }
            }
            animationFrameId = requestAnimationFrame(animate);
        };
        
        animationFrameId = requestAnimationFrame(animate);
        
        return () => {
            cancelAnimationFrame(animationFrameId);
        };
    }, []);

    return (
        <Container className="dm-services-container" maxWidth="lg">
            <Typography variant="h5" align="center" className="dm-services-title" data-aos="fade-up">
                Designing 
            </Typography>

            <div className="dm-carousel-wrapper">
                <div className="dm-carousel-track" ref={trackRef}>
                    {images.map((img, index) => (
                        <div className="dm-service-card" key={`first-${index}`}>
                            <img 
                                src={img} 
                                height="150" 
                                width="150" 
                                alt={`Designing Service ${index + 37}`} 
                            />
                        </div>
                    ))}
                    {images.map((img, index) => (
                        <div className="dm-service-card" key={`second-${index}`}>
                            <img 
                                src={img} 
                                height="150" 
                                width="150" 
                                alt={`Designing Service ${index + 37}`} 
                            />
                        </div>
                    ))}
                </div>
            </div>
        </Container>
    );
};

export default Carousel2;